<template>
  <section class="slider" id="slider">
    <div class="slider__container--one container">
      <div class="slider__indicator">{{ currentSlide + 1 }} / 3</div>
      <div class="slider__button" @click="moveSlide()">
        <svg
          width="37"
          height="16"
          viewBox="0 0 37 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M36.7071 8.70711C37.0976 8.31658 37.0976 7.68342 36.7071 7.29289L30.3431 0.928932C29.9526 0.538408 29.3195 0.538408 28.9289 0.928932C28.5384 1.31946 28.5384 1.95262 28.9289 2.34315L34.5858 8L28.9289 13.6569C28.5384 14.0474 28.5384 14.6805 28.9289 15.0711C29.3195 15.4616 29.9526 15.4616 30.3431 15.0711L36.7071 8.70711ZM0 9H36V7H0V9Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
    <ul class="slider__list">
      <li
        class="slider__item"
        v-for="slide of sliders"
        :key="slide.id"
        :class="{
          current: currentSlide === slide.id,
          prev: prevSlide === slide.id,
          next: nextSlide === slide.id,
          animated: animatedSlide === slide.id,
          prevZ: prevZ === slide.id,
          prevTranslate: prevTranslate === slide.id,
        }"
      >
        <div class="container slider__container">
          <div class="slider__top">Оригінальний препарат з Італії</div>
          <div class="slider__top-logo">
            <svg width="138" height="32" viewBox="0 0 138 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M137.724 17.6163H135.615V31.764H137.724V17.6163ZM134.47 17.6163H125.383V19.5596H128.873V31.764H130.999V19.5596H134.452L134.47 17.6163ZM117.859 27.3508L120.44 22.3564L123.075 27.3508H117.913L118.822 29.1669H124.147L125.401 31.6369H127.782C127.782 31.6369 122.948 22.1929 120.512 17.4891L113.243 31.6369H115.605L117.877 27.2781L117.859 27.3508ZM107.699 29.8207H104.664V19.5596H107.681C108.381 19.5179 109.082 19.6197 109.741 19.8587C110.4 20.0977 111.004 20.4689 111.514 20.9494C112.024 21.4299 112.431 22.0096 112.709 22.6529C112.987 23.2962 113.13 23.9894 113.13 24.6901C113.13 25.3908 112.987 26.0841 112.709 26.7273C112.431 27.3706 112.024 27.9504 111.514 28.4309C111.004 28.9114 110.4 29.2825 109.741 29.5216C109.082 29.7606 108.381 29.8624 107.681 29.8207H107.699ZM107.681 17.6163H102.52V31.764H107.681C108.641 31.8126 109.601 31.6657 110.502 31.3321C111.403 30.9986 112.227 30.4854 112.923 29.8237C113.62 29.1621 114.175 28.3658 114.554 27.4833C114.933 26.6008 115.128 25.6505 115.128 24.6901C115.128 23.7298 114.933 22.7795 114.554 21.897C114.175 21.0144 113.62 20.2182 112.923 19.5566C112.227 18.8949 111.403 18.3817 110.502 18.0481C109.601 17.7146 108.641 17.5677 107.681 17.6163ZM91.7057 19.5596H96.7946C97.1652 19.529 97.5381 19.5756 97.8897 19.6964C98.2414 19.8172 98.5642 20.0095 98.8377 20.2612C99.1112 20.513 99.3295 20.8186 99.4789 21.1589C99.6282 21.4992 99.7053 21.8668 99.7053 22.2384C99.7053 22.61 99.6282 22.9775 99.4789 23.3178C99.3295 23.6581 99.1112 23.9637 98.8377 24.2155C98.5642 24.4672 98.2414 24.6595 97.8897 24.7803C97.5381 24.9011 97.1652 24.9476 96.7946 24.9171H91.7057L98.6665 31.764H101.629L96.6673 26.8422H96.9581C97.5644 26.8422 98.1646 26.7229 98.7247 26.4911C99.2848 26.2593 99.7937 25.9195 100.222 25.4912C100.651 25.0628 100.991 24.5543 101.223 23.9946C101.455 23.4349 101.574 22.8351 101.574 22.2293C101.574 21.6235 101.455 21.0236 101.223 20.464C100.991 19.9043 100.651 19.3958 100.222 18.9674C99.7937 18.539 99.2848 18.1993 98.7247 17.9674C98.1646 17.7356 97.5644 17.6163 96.9581 17.6163H89.5974V31.764H91.7057V19.5596ZM81.019 29.966C79.9762 29.9517 78.9609 29.6296 78.1008 29.0402C77.2407 28.4509 76.5741 27.6206 76.185 26.6537C75.7958 25.6868 75.7014 24.6265 75.9136 23.6062C76.1258 22.5858 76.6351 21.651 77.3776 20.9191C78.1201 20.1872 79.0625 19.691 80.0864 19.4929C81.1103 19.2948 82.1699 19.4036 83.1321 19.8057C84.0943 20.2077 84.916 20.8851 85.494 21.7526C86.072 22.62 86.3804 23.6389 86.3805 24.681C86.3758 25.3798 86.2333 26.0709 85.9613 26.7146C85.6893 27.3584 85.293 27.9424 84.7951 28.4332C84.2973 28.9239 83.7076 29.3119 83.0597 29.5749C82.4117 29.8379 81.7183 29.9708 81.019 29.966ZM81.019 17.253C79.5628 17.2709 78.1445 17.7191 76.9427 18.5409C75.7409 19.3627 74.8093 20.5215 74.2653 21.8714C73.7212 23.2213 73.5891 24.7018 73.8855 26.1266C74.1818 27.5514 74.8935 28.8567 75.9308 29.8781C76.968 30.8995 78.2846 31.5913 79.7146 31.8665C81.1447 32.1417 82.6242 31.9879 83.9669 31.4244C85.3096 30.861 86.4554 29.9131 87.2601 28.7002C88.0647 27.4873 88.4923 26.0636 88.4888 24.6084C88.4696 22.6447 87.673 20.7684 86.2731 19.3901C84.8733 18.0117 82.9842 17.2433 81.019 17.253ZM68.1332 17.253C66.8923 17.2638 65.6742 17.5871 64.5915 18.1931C63.5088 18.7991 62.5966 19.6682 61.9391 20.7199C61.2817 21.7716 60.9003 22.9721 60.8303 24.2101C60.7603 25.4482 61.0038 26.6839 61.5385 27.803C62.0731 28.9221 62.8815 29.8884 63.889 30.6124C64.8964 31.3365 66.0704 31.7949 67.3022 31.9454C68.5339 32.0958 69.7838 31.9334 70.9361 31.4731C72.0884 31.0129 73.106 30.2697 73.8946 29.3122L72.8041 27.2237C72.3231 28.0343 71.6399 28.7065 70.8212 29.1744C70.0025 29.6424 69.0764 29.8901 68.1332 29.8934C67.4138 29.9356 66.6934 29.8304 66.0162 29.5843C65.3389 29.3383 64.7191 28.9565 64.1948 28.4625C63.6705 27.9684 63.2528 27.3725 62.9673 26.7113C62.6818 26.0501 62.5346 25.3376 62.5346 24.6175C62.5346 23.8974 62.6818 23.1849 62.9673 22.5237C63.2528 21.8625 63.6705 21.2666 64.1948 20.7725C64.7191 20.2785 65.3389 19.8967 66.0162 19.6506C66.6934 19.4046 67.4138 19.2994 68.1332 19.3416C69.0764 19.3449 70.0025 19.5927 70.8212 20.0606C71.6399 20.5285 72.3231 21.2007 72.8041 22.0114L73.9128 19.9409C73.2051 19.0975 72.3206 18.4196 71.3219 17.9551C70.3233 17.4907 69.2348 17.251 68.1332 17.253ZM54.9749 25.5891H59.573V23.664H53.012L54.9749 25.5891ZM53.0302 19.4869H59.573V17.5436H50.8856V31.6914H59.573V29.7481H53.012V19.4869H53.0302ZM40.0536 19.4869H45.1606C45.5312 19.4564 45.9041 19.503 46.2558 19.6237C46.6074 19.7445 46.9302 19.9368 47.2038 20.1886C47.4773 20.4403 47.6956 20.746 47.8449 21.0863C47.9943 21.4266 48.0713 21.7941 48.0713 22.1657C48.0713 22.5373 47.9943 22.9048 47.8449 23.2451C47.6956 23.5855 47.4773 23.8911 47.2038 24.1429C46.9302 24.3946 46.6074 24.5869 46.2558 24.7076C45.9041 24.8284 45.5312 24.875 45.1606 24.8445H40.0536L47.0144 31.6914H49.9951L45.0152 26.7878H45.306C45.9378 26.8273 46.571 26.7372 47.1666 26.5228C47.7622 26.3085 48.3075 25.9745 48.769 25.5414C49.2304 25.1083 49.5981 24.5853 49.8495 24.0047C50.1009 23.4242 50.2306 22.7983 50.2306 22.1657C50.2306 21.5331 50.1009 20.9073 49.8495 20.3267C49.5981 19.7461 49.2304 19.2231 48.769 18.79C48.3075 18.357 47.7622 18.023 47.1666 17.8086C46.571 17.5942 45.9378 17.504 45.306 17.5436H37.9453V31.6914H40.0536V19.4869Z" fill="white"/>
              <path d="M26.2593 22.2114L32.5113 15.9276L16.6813 0.0181791H4.06811L26.2593 22.2114ZM0.723997 12.6949L19.9163 31.8006H32.5113L0.723997 0V12.6949ZM0.723997 31.8006H16.554L0.723997 16.0184C0.705822 21.2125 0.742171 26.4793 0.723997 31.7461V31.8006Z" fill="white"/>
            </svg>
          </div>
          <div class="slider__text">
            <div
              class="slider__text-row"
              v-for="(row, index) of slide.rows"
              :key="index"
            >
              <p class="slider__text-animated" v-html="row"></p>
            </div>
          </div>

          <div class="slider__image">
            <div class="slider__elips slider__elips--fill"></div>
            <div class="slider__elips slider__elips--border"></div>
            <div class="slider__elips slider__elips--img"></div>
          </div>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data: () => ({
    currentSlide: 0,
    nextSlide: 1,
    prevSlide: null,
    prevZ: null,
    prevTranslate: null,

    animatedSlide: null,

    sliders: [
      {
        id: 0,
        rows: [
          '<h1 class="content__primary-title"><strong>Ломексин<sup>®</sup></strong></h1>',
          `<h1 class="content__primary-title">Невелике зусилля —</h1>`,

          `<h1 class="content__primary-title">Невелике</h1>`,
          `<h1 class="content__primary-title">зусилля —</h1>`,

          '<h1 class="content__primary-title">значний<h1>',
          '<h1 class="content__primary-title">результат!</h1>',
          "<p>Сприяє швидкому усуненню свербежу, печіння та виділення з піхви</p>",
        ],
      },
      {
        id: 1,
        rows: [
          '<h1 class="content__primary-title"><strong>Ломексин<sup>®</sup></strong>—</h1>',
          '<h1 class="content__primary-title">один день</h1>',
          '<h1 class="content__primary-title">для лікування<h1>',
          '<h1 class="content__primary-title">молочниці!</h1>',
          "<p>Протигрибковий засіб широкого спектра дії</p>",
        ],
      },
      {
        id: 2,
        rows: [
          '<h1 class="content__primary-title">Постав крапку </h1>',
          '<h1 class="content__primary-title">в історії молочниці</h1>',

          '<h1 class="content__primary-title">в історії</h1>',
          '<h1 class="content__primary-title">молочниці</h1>',

          '<h1 class="content__primary-title">разом <h1>',
          '<h1 class="content__primary-title"><strong>з Ломексин<sup>®</sup></strong></h1>',
          "<p>Оригінальний препарат з унікальною* діючою <nobr>речовиною –</nobr> фентиконазолу нітрат</p>",
        ],
      },
    ],
  }),
  methods: {
    moveSlide() {
      this.animatedSlide = this.currentSlide;

      setTimeout(() => {
        this.prevSlide = this.currentSlide;

        if (this.currentSlide === 2) {
          this.currentSlide = 0;
        } else {
          this.currentSlide++;
        }

        if (this.currentSlide === 2) {
          this.nextSlide = 0;
        } else {
          this.nextSlide = this.currentSlide + 1;
        }
      }, 1000);

      setTimeout(() => {
        this.prevZ = this.prevSlide;
      }, 1500);

      setTimeout(() => {
        this.prevTranslate = this.prevSlide;
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
.slider {
  position: relative;
  padding-top: 90px;
  overflow: hidden;
  width: 100%;

  @media screen and (max-width: 1235px){
    padding-top: 70px;
  }

  &__indicator {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 112px;
    height: 58px;
    color: #fff;
    border: 2px solid;
    border-radius: 50%;
    bottom: 104px;
    font-size: 20px;
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: -10%;
    top: 50%;
    width: 120px;
    height: 120px;
    transform: translateY(-50%);
    z-index: 4;
    cursor: pointer;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-image: url(../assets/img/text.svg);
      background-size: contain;
      animation: loop 5s infinite linear;
    }
  }

  &__list {
    padding-top: 134px;
    position: relative;
    display: flex;
    height: 780px;
  }

  &__item {
    width: 100%;
    height: 780px;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    transform: translateX(0);
    border-radius: 0px 60px 60px 0px;
    transition: all 0.4s;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 229px;
      height: 229px;
      transition: all 0.6s;
      transition-delay: 0.2s;
      animation: opacity 0.4s alternate;
    }

    &.current {
      z-index: 2;
      left: -100px;

      & .slider__text-animated {
        transform: translateY(0);
        animation: textAnimation 2s alternate;
      }

      & .slider__elips,
      & .slider__top,
      & .slider__top-logo {
        opacity: 1;
        animation: opacity 3.5s alternate;
      }
    }

    &.prev {
      z-index: 3;
      transform: translateX(-100%);
    }

    &.prevZ {
      z-index: -1;
    }

    &.prevTranslate {
      transform: translateX(0);
    }

    &.next {
      transform: translateX(0);
      z-index: 1;
      left: -50px;
    }

    &:nth-child(1) {
      background-color: #a81d7b;
      animation: slider 2s alternate;

      &::before {
        background-image: url(../assets/img/slider-1-dec.svg);
        left: 50px;
        top: 96px;
      }

      .slider__top {
        &::before {
          background: #d65db4;
        }
      }

      .slider__text {
        &-row:nth-child(2) {
          padding-left: 43px;
        }
        &-row:nth-child(3),
        &-row:nth-child(4) {
          display: none;
        }
        &-row:nth-child(5) {
          padding-left: 290px;
        }
        &-row:nth-child(6) {
          padding-left: 141px;
        }
        &-row:nth-child(7) {
          max-width: 60%;
          padding-left: 293px;
          margin-top: 23px;
          margin-bottom: 0;
          font-size: 18px;
          line-height: 150%;
          text-transform: uppercase;
        }
      }

      .slider__elips {
        &--fill {
          top: 55%;
          left: 30%;
          background-color: #e67bc4;
          transform: rotate(-15.23deg);
        }

        &--border {
          top: 35%;
          left: 20%;
          transform: rotate(-60.23deg);
        }

        &--img {
          top: 45%;
          left: 24%;
          transform: rotate(-40deg);

          &::before {
            top: -155%;
            left: -100%;
            bottom: -25%;
            right: -55%;
            background-image: url(../assets/img/slider-1.png);
            transform: rotate(40deg);
          }
        }
      }

      &.animated {
        .slider__elips--img {
          width: 1329px;
          height: 688px;
          top: 0;
          right: 0;
          left: -10%;

          &::before {
            top: -14%;
            left: -12%;
            bottom: 0;
            right: 8%;
          }
        }
      }
    }

    &:nth-child(2) {
      background-color: #d051a7;
      animation: slider 1.5s alternate;

      &::before {
        background-image: url(../assets/img/slider-3-dec.svg);
        width: 211px;
        height: 211px;
        left: 121px;
        top: 378px;
      }

      .slider__text {
        &-row:nth-child(2) {
          padding-left: 290px;
        }
        &-row:nth-child(3) {
          padding-left: 51px;
        }
        &-row:nth-child(4) {
          padding-left: 140px;
        }
        &-row:nth-child(5) {
          max-width: 85%;
          padding-left: 293px;
          margin-top: 23px;
          margin-bottom: 0;
          font-size: 18px;
          line-height: 150%;
          text-transform: uppercase;
        }
      }

      .slider__elips {
        &--fill {
          top: 25%;
          left: 20%;
          background-color: #e67bc4;
          transform: rotate(-126deg);
        }

        &--border {
          top: 50%;
          left: 30%;
          transform: rotate(-160deg);
        }

        &--img {
          top: 45%;
          left: 34%;
          transform: rotate(-53deg);

          &::before {
            top: -100%;
            left: -120%;
            bottom: -180%;
            right: -100%;
            background-image: url(../assets/img/slider-2.png);
            transform: rotate(53deg);
          }
        }
      }

      &.animated {
        .slider__elips--img {
          width: 1329px;
          height: 688px;
          top: 0;
          right: 0;
          left: -10%;

          &::before {
            top: -20%;
            left: -12%;
            bottom: 0;
            right: 8%;
          }
        }
      }
    }

    &:nth-child(3) {
      background-color: #e77bc4;
      animation: slider 1s alternate;

      &::before {
        background-image: url(../assets/img/slider-2-dec.svg);
        width: 191px;
        height: 191px;
        left: 92px;
        top: 135px;
      }

      .slider__text {
        &-row:nth-child(2) {
          padding-left: 46px;
        }
        &-row:nth-child(3),
        &-row:nth-child(4) {
          display: none;
        }
        &-row:nth-child(5) {
          padding-left: 194px;
        }
        &-row:nth-child(6) {
          padding-left: 146px;
        }
        &-row:nth-child(7) {
          max-width: 65%;
          padding-left: 293px;
          margin-top: 23px;
          margin-bottom: 0;
          font-size: 18px;
          line-height: 150%;
          text-transform: uppercase;
        }
      }

      .slider__elips {
        &--fill {
          top: 55%;
          left: 40%;
          background-color: #d258ab;
          transform: rotate(-25deg);
        }

        &--border {
          top: 40%;
          left: 40%;
          transform: rotate(-55deg);
        }

        &--img {
          top: 50%;
          left: 30%;
          transform: rotate(24deg);

          &::before {
            top: -95%;
            left: -70%;
            bottom: -130%;
            right: -30%;
            background-image: url(../assets/img/slider-3.png);
            transform: rotate(-24deg);
          }
        }
      }

      &.animated {
        .slider__elips--img {
          width: 1329px;
          height: 688px;
          top: 0;
          right: 0;
          left: -20%;

          &::before {
            top: -0%;
            left: -0%;
            bottom: -10%;
            right: 0%;
          }
        }
      }
    }

    &.animated {
      .slider__text-animated {
        transform: translateY(120%);
      }

      &::before,
      .slider__elips--fill,
      .slider__elips--border {
        opacity: 0;
      }
    }
  }

  &__container {
    display: flex;
    justify-content: space-between;
    transform: translateX(100px);
    height: 90%;

    &--one {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 90%;
      z-index: 4;
    }
  }

  &__top {
    position: absolute;
    top: 35px;
    font-size: 20px;
    line-height: 22px;
    text-align: center;
    text-transform: uppercase;
    color: #ffffff;
    opacity: 0;
    transition: all 0.4s;
    animation: opacity 4s alternate;

    &::before {
      content: "";
      position: absolute;
      z-index: -1;
      width: 450.15px;
      height: 233.68px;
      left: -10%;
      top: -190px;
      border-radius: 50%;

      background: #a81d7b;
      transform: rotate(12.79deg);
    }
  }

  &__top-logo {
    position: absolute;
    top: 13px;
    right: 95px;
    opacity: 0;
    transition: all 0.4s;
    animation: opacity 4s alternate;
  }

  &__text {
    position: relative;
    color: #ffffff;
    transition: all 0.4s;
    top: 136px;

    &-row {
      margin-bottom: 8px;
      position: relative;
      overflow: hidden;
    }

    &-animated {
      transition: all 0.4s;
      transition-delay: 0.4s;
      transform: translateY(120%);
    }
  }

  &__image {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 60%;
  }

  &__elips {
    position: absolute;
    width: 540px;
    height: 280px;
    border-radius: 50%;
    opacity: 0;
    transition: all 0.4s;

    &--fill {
      z-index: -1;
    }

    &--border {
      z-index: -1;
      border: 2px solid #ffffff;
    }

    &--img {
      z-index: -1;
      background-color: transparent;
      overflow: hidden;
      transition: all 0.4s;
      transition-delay: 0.4s;

      &::before {
        content: "";
        position: absolute;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        transition: all 0.4s;
        transition-delay: 0.4s;
        z-index: -1;
      }
    }
  }

  @media (max-width: 1441px) {
    &__button {
      right: 5%;
    }

    &__indicator {
      font-size: 16px;
    }

    &__list {
      height: 708px;
    }

    &__item {
      height: 708px;

      &::before {
        width: 160px;
        height: 160px;
      }

      &.current {
        left: -80px;
      }

      &.next {
        left: -40px;
      }

      &:nth-child(1) {
        &::before {
          left: 50px;
          top: 52px;
        }

        .slider__elips {
          &--fill {
            top: 55%;
            left: 20%;
          }

          &--border {
            top: 35%;
            left: 10%;
          }

          &--img {
            top: 45%;
            left: 15%;
          }
        }

        &.animated {
          .slider__elips--img {
            width: 800px;
            height: 400px;
            top: 20%;
            left: -15%;

            &::before {
              top: -25%;
              left: 0;
              bottom: -25%;
              right: 0;
            }
          }
        }
      }

      &:nth-child(2) {
        &::before {
          left: 30px;
          top: 298px;
        }

        .slider__text {
          &-row:nth-child(5) {
            max-width: 80%;
          }
        }

        .slider__elips {
          &--fill {
            top: 25%;
            left: 10%;
          }

          &--border {
            top: 45%;
            left: 20%;
          }

          &--img {
            top: 45%;
            left: 15%;
          }
        }

        &.animated {
          .slider__elips--img {
            width: 800px;
            height: 400px;
            top: 20%;
            left: -15%;

            &::before {
              top: -40%;
              left: 0;
              bottom: -40%;
              right: 0;
            }
          }
        }
      }

      &:nth-child(3) {
        &::before {
          left: 40px;
          top: 233px;
        }

        .slider__text {
          &-row:nth-child(7) {
            max-width: 55%;
          }
        }

        .slider__elips {
          &--fill {
            top: 55%;
            left: 15%;
          }

          &--border {
            top: 35%;
            left: 15%;
          }

          &--img {
            top: 45%;
            left: 15%;
          }
        }

        &.animated {
          .slider__elips--img {
            width: 800px;
            height: 400px;
            top: 20%;
            left: -15%;

            &::before {
              top: -25%;
              left: 0;
              bottom: -25%;
              right: 0;
            }
          }
        }
      }
    }

    &__container {
      transform: translateX(80px);
    }

    &__text {
      top: 116px;

      &-row {
        margin-bottom: 5px;
      }
    }

    &__elips {
      width: 460px;
      height: 240px;
    }

    &__top-logo {
      top: 10px;
      right: 100px;
    }
  }

  @media (max-width: 1100px) {
    //padding-top: 70px;

    &__button {
      right: 120px;
    }

    &__indicator {
      font-size: 12px;
      width: 100px;
      height: 50px;
    }

    &__list {
      height: 900px;
    }

    &__item {
      height: 900px;

      &::before {
        width: 140px;
        height: 140px;
      }

      &:nth-child(1) {
        &::before {
          top: 240px;
        }

        .slider__text {
          &-row:nth-child(2) {
            padding-left: 43px;
          }
          &-row:nth-child(5) {
            padding-left: 236px;
          }
          &-row:nth-child(6) {
            padding-left: 114px;
          }
          &-row:nth-child(7) {
            max-width: 70%;
            left: 50%;
            transform: translateX(-50%);
            padding-left: 0;
            margin-top: 10px;
            font-size: 12px;
          }
        }

        .slider__elips {
          &--fill {
            left: 10%;
            top: 65%;
          }

          &--border {
            left: 0%;
            top: 50%;
          }

          &--img {
            left: 0%;
            top: 55%;
          }
        }

        &.animated {
          .slider__elips--img {
            left: -30%;
            top: 40%;
          }
        }
      }

      &:nth-child(2) {
        &::before {
          left: 81px;
          top: 276px;
          width: 140px;
          height: 140px;
        }

        .slider__text {
          &-row:nth-child(2) {
            padding-left: 163px;
          }
          &-row:nth-child(3) {
            padding-left: 115px;
          }
          &-row:nth-child(4) {
            padding-left: 274px;
          }
          &-row:nth-child(5) {
            max-width: 80%;
            padding-left: 274px;
            margin-top: 10px;
            font-size: 12px;
          }
        }

        .slider__elips {
          &--fill {
            left: 18%;
            top: 52%;
          }

          &--border {
            left: 20%;
            top: 60%;
          }

          &--img {
            left: 20%;
            top: 60%;
          }
        }

        &.animated {
          .slider__elips--img {
            left: -30%;
            top: 40%;
          }
        }
      }

      &:nth-child(3) {
        &::before {
          left: 103px;
          top: 310px;
          width: 140px;
          height: 140px;
        }

        .slider__text {
          &-row:nth-child(2) {
            padding-left: 43px;
          }
          &-row:nth-child(5) {
            padding-left: 290px;
          }
          &-row:nth-child(6) {
            padding-left: 141px;
          }
          &-row:nth-child(7) {
            max-width: 70%;
            padding-left: 274px;
            margin-top: 10px;
            padding-left: 274px;
            font-size: 12px;
          }
        }

        .slider__elips {
          &--fill {
            left: 26%;
            top: 66%;
          }

          &--border {
            left: 25%;
            top: 57%;
          }

          &--img {
            left: 20%;
            top: 60%;
          }
        }

        &.animated {
          .slider__elips--img {
            left: -30%;
            top: 40%;
          }
        }
      }
    }

    &__top {
      font-size: 18px;
      top: 20px;
      left: auto;
      right: 300px;

      &::before {
        width: 463.85px;
        height: 240.79px;
        top: -200px;
      }
    }

    &__text {
      top: 66px;
    }

    &__image {
      width: 80%;
    }

    &__elips {
      width: 400px;
      height: 200px;
    }

    &__top-logo {
      right: auto;
      left: 40px;
    }
  }

  @media (max-width: 769px) {
    &__button {
      right: 80px;
    }

    &__indicator {
      width: 100px;
      height: 50px;
      bottom: 90px;
    }

    &__list {
      height: 900px;
    }

    &__item {
      height: 900px;

      &.current {
        left: -38px;
      }

      &.next {
        left: -19px;
      }

      &:nth-child(1) {
        &::before {
          left: 20px;
        }

        .slider__text {
          &-row:nth-child(2) {
            padding-left: 43px;
          }
          &-row:nth-child(5) {
            padding-left: 236px;
          }
          &-row:nth-child(6) {
            padding-left: 114px;
          }
          &-row:nth-child(7) {
            left: 53%;
            max-width: 40%;
            font-size: 12px;
          }
        }

        .slider__elips {
          &--fill {
            left: 27%;
            top: 65%;
          }

          &--border {
            left: 15%;
            top: 50%;
          }

          &--img {
            left: 20%;
            top: 55%;
          }
        }

        &.animated {
          .slider__elips--img {
            left: -30%;
            top: 40%;
          }
        }
      }

      &:nth-child(2) {
        .slider__text {
          &-row:nth-child(2) {
            padding-left: 163px;
          }
          &-row:nth-child(3) {
            padding-left: 115px;
          }
          &-row:nth-child(4) {
            padding-left: 274px;
          }
          &-row:nth-child(5) {
            font-size: 12px;
          }
        }

        &.animated {
          .slider__elips--img {
            left: -30%;
            top: 40%;
          }
        }
      }

      &:nth-child(3) {
        .slider__text {
          &-row:nth-child(2) {
            padding-left: 43px;
          }
          &-row:nth-child(5) {
            padding-left: 290px;
          }
          &-row:nth-child(6) {
            padding-left: 141px;
          }
          &-row:nth-child(7) {
            font-size: 12px;
          }
        }

        &.animated {
          .slider__elips--img {
            left: -10%;
            top: 40%;
          }
        }
      }
    }

    &__container {
      transform: translateX(38px);
    }

    &__top {
      font-size: 16px;
      left: 273px;
      right: auto;

      &::before {
        width: 378.1px;
        height: 196.28px;
      }
    }

    &__text {
      top: 66px;
    }

    &__image {
      width: 100%;
    }
  }

  @media (max-width: 650px) {
    padding-top: 60px;

    &__button {
      width: 74px;
      height: 74px;
      right: 60px;
      bottom: 45px;
      top: auto;
      transform: translate(0);
    }

    &__indicator {
      height: auto;
      width: auto;
      bottom: 45px;
      border: none;
      font-size: 10px;
    }

    &__list {
      height: 616px;
    }

    &__item {
      height: 616px;
      border-radius: 0 40px 40px 0;

      & .slider__top {
        font-size: 12px;
        top: 15px;
        left: 14px;
        right: auto;

        &::before {
          width: 238px;
          height: 123px;
          top: -95px;
        }
      }

      &::before {
        display: none;
      }

      &.current {
        left: -30px;
      }

      &.next {
        left: -15px;
      }

      &:nth-child(1) {
        .slider__text {
          &-row:nth-child(2) {
            display: none;
          }
          &-row:nth-child(3) {
            display: block;
            padding-left: 57px;
          }
          &-row:nth-child(4) {
            display: block;
            padding-left: 106px;
          }
          &-row:nth-child(5) {
            padding-left: 57px;
          }
          &-row:nth-child(6) {
            padding-left: 106px;
          }
          &-row:nth-child(7) {
            max-width: 85%;
            padding-left: 107px;
            font-size: 10px;
          }
        }

        .slider__elips {
          &--fill {
            left: -5%;
            top: 65%;
          }

          &--border {
            left: -15%;
            top: 53%;
          }

          &--img {
            left: -15%;
            top: 58%;
          }
        }

        &.animated {
          .slider__elips--img {
            width: 270px;
            height: 140px;
            left: -15%;
            top: 55%;

            &::before {
              top: -155%;
              left: -100%;
              bottom: -25%;
              right: -55%;
            }
          }
        }
      }

      &:nth-child(2) {
        .slider__text {
          &-row:nth-child(n + 2) {
            padding-left: 26px;
          }
          &-row:nth-child(n + 3) {
            padding-left: 0px;
          }
          &-row:nth-child(n + 4) {
            padding-left: 74px;
          }
          &-row:nth-child(n + 5) {
            max-width: 90%;
            left: 0;
            transform: translateX(0);
            padding-left: 78px;
            font-size: 10px;
          }
        }

        .slider__elips {
          &--fill {
            left: -8%;
            top: 45%;
          }

          &--border {
            left: 5%;
            top: 55%;
          }

          &--img {
            left: 5%;
            top: 55%;
          }
        }

        &.animated {
          .slider__elips--img {
            width: 270px;
            height: 140px;
            left: 5%;
            top: 55%;

            &::before {
              top: -100%;
              left: -120%;
              bottom: -180%;
              right: -100%;
            }
          }
        }
      }

      &:nth-child(3) {
        .slider__text {
          &-row:nth-child(2) {
            display: none;
          }
          &-row:nth-child(3) {
            display: block;
            padding-left: 58px;
          }
          &-row:nth-child(4) {
            display: block;
            padding-left: 105px;
          }
          &-row:nth-child(5) {
            padding-left: 31px;
          }
          &-row:nth-child(6) {
            padding-left: 59px;
          }
          &-row:nth-child(7) {
            max-width: 90%;
            left: 0;
            transform: translateX(0);
            padding-left: 78px;
            font-size: 10px;
          }
        }

        .slider__elips {
          &--fill {
            left: 5%;
            top: 70%;
          }

          &--border {
            left: 5%;
            top: 60%;
          }

          &--img {
            left: -5%;
            top: 65%;
          }
        }

        &.animated {
          .slider__elips--img {
            width: 270px;
            height: 140px;
            left: -5%;
            top: 55%;

            &::before {
              top: -95%;
              left: -70%;
              bottom: -130%;
              right: -30%;
            }
          }
        }
      }
    }

    &__container {
      transform: translateX(30px);
    }

    &__text {
      top: 76px;

      &-row {
        margin-bottom: 3px;
      }
    }

    &__image {
      width: 100%;
    }

    &__elips {
      width: 270px;
      height: 140px;
    }

    &__top-logo {
      right: auto;
      left: 14px;
      top: 45px;

      svg {
        max-width: 90px;
      }
    }
  }
}

@keyframes textAnimation {
  0% {
    transform: translateY(120%);
  }
  80% {
    transform: translateY(120%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes loop {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  70% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slider {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
